import {ChevronLeftIcon} from '@chakra-ui/icons'
import {Box, Heading, HStack, Link, ListItem, Stack, Text, UnorderedList} from '@chakra-ui/react'
import NextLink from 'next/link'

const Privacy = () => {
  return (
    <Stack px={[2, null, 3]} spacing={6}>
      <Stack spacing={1}>
        <HStack spacing={1}>
          <ChevronLeftIcon/>
          <NextLink href="/" passHref>
            <Link>Home</Link>
          </NextLink>
        </HStack>
        <Heading mb={4}>Privacy policy</Heading>
      </Stack>

      <Text>Last updated June 08, 2021</Text>

      <Stack spacing={4}>
        <Stack>
          <Text>
            This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your
            information when You use the Service and tells You about Your privacy rights and how the law protects You.
          </Text>
          <Text>
            We collect usage data to provide and improve the Service. By using the Service, You agree to the collection
            and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the
            help of the Privacy Policy Generator.
          </Text>
        </Stack>
      </Stack>

      <Stack spacing={4}>
        <Heading size="lg">Interpretation and Definitions</Heading>
        <Stack spacing={2}>
          <Heading size="md">Interpretation</Heading>
          <Text>
            The words of which the initial letter is capitalized have meanings defined under the following conditions.
            The following definitions shall have the same meaning regardless of whether they appear in singular or in
            plural.
          </Text>
        </Stack>

        <Stack>
          <Heading size="md">Definitions</Heading>
          <Text>For the purposes of this Privacy Policy:</Text>
          <Box>
            <UnorderedList>
              <Stack>
                <ListItem>
                  <strong>Company</strong>{' '}
                  {`(referred to as either "the Company", "We", "Us" or "Our" in this Agreement)
                  refers to CIta Previa Valencia`}
                </ListItem>
                <ListItem>
                  <strong>Device</strong> means any device that can access the Service such as a computer, a cellphone
                  or a digital tablet.
                </ListItem>
                <ListItem>
                  <strong>Service</strong> refers to the Website.
                </ListItem>
                <ListItem>
                  <strong>Service Provider</strong> means a means any natural or legal person who processes the data on
                  behalf of the Company. It refers to third-party companies or individuals employed by the Company to
                  facilitate the Service, to provide the Service on behalf of the Company, to perform services related
                  to the Service or to assist the Company in analyzing how the Service is used.
                </ListItem>
                <ListItem>
                  <strong>Usage Data</strong> means a refers to data collected automatically, either generated by the
                  use of the Service or from the Service infrastructure itself (for example, the duration of a page
                  visit).
                </ListItem>
                <ListItem>
                  <strong>Website</strong> means a refers to CIta Previa Valencia, accessible from{' '}
                  <span>
                    <Link href="https://citapreviavalencia.com">https://citapreviavalencia.com</Link>
                  </span>
                </ListItem>
                <ListItem>
                  <strong>You</strong> means a means the individual accessing or using the Service, or the company, or
                  other legal entity on behalf of which such individual is accessing or using the Service, as
                  applicable.
                </ListItem>
              </Stack>
            </UnorderedList>
          </Box>
        </Stack>

        <Stack spacing={4}>
          <Heading size="lg">Collecting and Using Your Personal Data</Heading>
          <Stack>
            <Heading size="md">Types of Data Collected</Heading>
          </Stack>

          <Stack>
            <Heading size="xs">Personal Data</Heading>
            <Text>We do not collect your Personal Data</Text>
          </Stack>

          <Stack>
            <Heading size="xs">Usage Data</Heading>
            <Text>Usage Data is collected automatically when using the Service.</Text>
            <Text>
              {`Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address),
              browser type, browser version, the pages of our Service that You visit, the time and date of Your visit,
              the time spent on those pages, unique device identifiers and other diagnostic data.`}
            </Text>
            <Text>
              When You access the Service by or through a mobile device, We may collect certain information
              automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique
              ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet
              browser You use, unique device identifiers and other diagnostic data.
            </Text>
            <Text>
              We may also collect information that Your browser sends whenever You visit our Service or when You access
              the Service by or through a mobile device.
            </Text>
          </Stack>
        </Stack>

        <Stack spacing={4}>
          <Heading size="md">Links to Other Websites</Heading>
          <Text>
            {`Our Service may contain links to other websites that are not operated by Us. If You click on a third party
            link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy
            of every site You visit.`}
          </Text>
          <Text>
            We have no control over and assume no responsibility for the content, privacy policies or practices of any
            third party sites or services.
          </Text>
        </Stack>
      </Stack>

      <Stack spacing={4}>
        <Heading size="lg">Changes to this Privacy Policy</Heading>
        <Text>
          You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are
          effective when they are posted on this page.
        </Text>
      </Stack>

      <Text py={10}>Privacy Policy for CIta Previa Valencia</Text>
    </Stack>
  )
}

export default Privacy
